import AuthApi from "api/auth"
import { Request } from 'api'
    
//constatnts
    import * as ActionsState from 'constants/ActionsState'

export default class User {
    constructor( core ) {
        this.core = core
    }

    Registration({ name, email }) {
        const { store } = this.core

        const { origin } = store.getState()

        return Request( AuthApi.Registration, { name, email, origin })
    }

    ConfirmRegistration({ code, confirm_id }) {
        const { store } = this.core

        const { origin } = store.getState()

        return Request( AuthApi.ConfirmRegistration, { code, confirm_id, origin })
    }

    Auth({ email, password }) {        
        return this.core.DataStatus
            .createRequest([ AuthApi.Authorization, { email, password } ], 'user' )
            .onComplete( response => this.SaveAuth( response.access_token ) )
            .start({
                logName: "User::Auth"
            })
    }

    AuthByUser = (user) => {
        this.SaveAuth(user.access_token)

        this.core.updateStore({
            user: { $set: user },
            ...this.core.DataStatus.setInfoRequest("user", ActionsState.LOADED)
        }, "[BaseAuth][AuthByUser]")
    }

    AuthByKey( token ) {
        return this.core.DataStatus
            .createRequest([AuthApi.AuthorizationByToken, { token } ], 'user' )
            .onComplete(response => this.SaveAuth(response.access_token ) )
            .start({
                logName: "User::Auth"
            })
    }

    AuthBySaveKey() {
        const auth_key = this.core.LocalStore.Get( 'user_auth_key' )

        if( auth_key )
        {
            return this.AuthByKey( auth_key )
        }
    }

    async Logout() {
        const { store } = this.core

        const { origin } = store.getState()

        try {
            await Request( AuthApi.Logout, { origin })
        } catch(e) {
            console.log(e)
        }

        this.SaveAuth( "" )
        
        this.core.updateStore({
            ...this.core.DataStatus.setInfoRequest( "user", ActionsState.NOT_LOAD, false ),
            user: {$set: false}
        })
    }

    /*Сохранение токена в localStore*/
    SaveAuth(access_token) {
        this.core.Log('[BaseAuth][SaveAuth]', { access_token })

        this.core.LocalStore.Set( 'user_auth_key', access_token )

        this.SetBearer( access_token )
    }

    /*Создание конфигурации Bearer аутентификации для api*/
    SetBearer( access_token = "" ) {
        if( access_token )
        {
            window.allowBearerAuth = true
            window.credenrialsBearerAuth = access_token
        } else {
            window.allowBearerAuth = false
            window.credenrialsBearerAuth = ""
        }

        this.core.Log( '[BaseAuth][SetBearer]', {
            allowBearerAuth: window.allowBearerAuth,
            credenrialsBearerAuth: window.credenrialsBearerAuth
        })
    }

    IsAuth() {
        if( this.core.DataStatus.isLoaded( 'user' ) )
        {
            return true
        }

        return false
    }
}